import { Component, ViewChild } from '@angular/core';
import { Platform, AlertController, MenuController, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
//import { OneSignal } from '@ionic-native/onesignal';

import { LoginPage } from '../pages/login/login';
import { PreloginPage } from '../pages/prelogin/prelogin';

import { BusinessMainPage } from '../pages/business-main/business-main';
import { ConsumerMainPage } from '../pages/consumer-main/consumer-main';
import { StamperMainPage } from '../pages/stamper-main/stamper-main';
import { CashierMainPage } from '../pages/cashier-main/cashier-main';
import { ExpeditorMainPage } from '../pages/expeditor-main/expeditor-main';
import { CustomSplashPage } from '../pages/custom-splash/custom-splash';
import { DownloadLatestVersionPage } from '../pages/download-latest-version/download-latest-version';

import { ConsumerMessageDetailPage } from '../pages/consumer-message-detail/consumer-message-detail';

import { Globals } from '../providers/globals';
import { PaymentMethodHandler } from '../providers/payment-method-handler';
import { BusinessManagerHandler } from '../providers/business-manager-handler';
import { CustomSplashHandlerProvider } from '../providers/custom-splash-handler';
import { ConsumerPointsHandlerProvider } from '../providers/consumer-points-handler';
import { AuthProvider } from '../providers/auth';
import { PushNotificationHandlerProvider } from '../providers/push-notification-handler';

import { Storage } from '@ionic/storage';
import { Camera } from '@ionic-native/camera';

declare var bumerang: any;
//import * as firebase from "firebase";

// const config = {
//   apiKey: "AIzaSyD83CySgjIn8ytDk6DLDYA_KFr-z5YQqCM",
//   authDomain: "bumerang-1516071100038.firebaseapp.com",
//   databaseURL: "https://bumerang-1516071100038.firebaseio.com",
//   projectId: "bumerang-1516071100038",
//   storageBucket: "bumerang-1516071100038.appspot.com",
//   messagingSenderId: "353892765611"
// };

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any;
  isLoggedIn: boolean;
  splash: any;
  imageClasses: any = "logo animated fadeIn";

  @ViewChild('content') nav;
  isLoading: boolean = false;
  loadingMsg: any = "Loading...";
  appIsStarting: boolean = false;

  constructor(
    public platform: Platform, 
    public statusBar: StatusBar,   
    public splashScreen: SplashScreen,  
    public globals: Globals,
    public paymentMethodHandler: PaymentMethodHandler,  
    public customSplashHandlerProvider: CustomSplashHandlerProvider, 
    public consumerPointsHandlerProvider: ConsumerPointsHandlerProvider,
    public authProvider: AuthProvider,
    public storage: Storage,
    public alertCtrl: AlertController,
    public menu: MenuController,
    public modalCtrl: ModalController,
    private pushNotificationHandlerProvider: PushNotificationHandlerProvider,
    ) {
      
      platform.ready().then((readySource) => {
        // this.statusBar.styleDefault();
  
        this.isLoading = true;
        this.loadingMsg = "Loading Bumerang..."        

        this.authProvider.logMessage("Before readySource");

        this.storage.get('loginData').then((loginData) => {        
          this.globals.loginData = loginData;
        });

        if(readySource!="dom"){
          this.authProvider.logMessage("Entered readySource!=dom")
          this.pushNotificationHandlerProvider.handlerNotifications((data)=>{
            this.authProvider.logMessage("this.pushNotificationHandlerProvider")
            this.handleNotificationClick(data);
          });
        }  
      });

      //firebase.initializeApp(config);
  }

  handleNotificationClick(data){
    this.authProvider.logMessage("this.globals.messageId: " + this.globals.messageId)
    this.authProvider.logMessage("this.globals.loginData.access_token: " + this.globals.loginData.access_token)

    var interval = setInterval(()=>{
      this.authProvider.logMessage("this.appIsStarting: " + this.appIsStarting)
      this.authProvider.logMessage("interval loop")

      if(!this.appIsStarting){
        clearInterval(interval);        
        this.authProvider.logMessage("clearInterval")

        this.authProvider.logMessage("this.globals.messageId: " + this.globals.messageId)
        this.authProvider.logMessage("this.globals.loginData.access_token: " + this.globals.loginData.access_token)

        if(this.globals.messageId!="" && this.globals.loginData.access_token!=""){
           
            let profileModal = this.modalCtrl.create(ConsumerMessageDetailPage);
            profileModal.present();    

        }
      }

    }, 500);

  }

  ngAfterViewInit() {
    console.log('ngAfterViewInit');

    this.appIsStarting = true;

    this.customSplashHandlerProvider.subscription.subscribe(params => {
      if(params.finished){
        console.log("params.finished = true");

        this.imageClasses = "logo animated fadeOut";

        console.log("this.imageClasses: " + this.imageClasses)

        setTimeout(()=>{    
          this.platform.ready().then((readySource) => {
            this.splashScreen.hide();
          });

          this.isLoading = false;
              
          // this.statusBar.styleDefault();    

          if(this.globals.currentRole=="Consumer"){
            this.nav.setRoot(ConsumerMainPage);
          } else if(this.globals.currentRole=="Stamper"){
            this.nav.setRoot(StamperMainPage);
          }  else if(this.globals.currentRole=="Cashier"){
            this.nav.setRoot(CashierMainPage);
          } else if(this.globals.currentRole=="Expeditor"){
            this.nav.setRoot(ExpeditorMainPage);
          } else {
            this.nav.setRoot(BusinessMainPage);
          }

          this.appIsStarting = false;

          this.pushNotificationHandlerProvider.subsribeUserByRole(this.globals.currentRole);
        }, 600)
      }    
    });    

    this.loadingMsg = "Getting version...";

    console.log(this.loadingMsg);

    setTimeout(()=>{
      this.imageClasses = "logo";

      console.log("verifyVersion");

      this.verifyVersion();
    }, 500)
  }

  verifyVersion(){
    this.authProvider.verifyVersionUpToDate(
      (lastest)=>{
        //console.log("lastest: " + lastest);

        // if(!lastest){
        //   this.platform.ready().then((readySource) => {
        //     this.splashScreen.hide();
        //   });
          
        //   this.nav.setRoot(DownloadLatestVersionPage);

        //   return;
        // } 

        //console.log("after latest");

        this.loadingMsg = "Loading session...";

        this.storage.get('loginData').then((loginData) => {
          if(loginData){
            this.globals.loginData = loginData;
          }

          console.log("before ping");

          this.authProvider.ping()
          .then( data => {                
            this.init();
          })
          .catch( error => {
            this.platform.ready().then((readySource) => {
              this.splashScreen.hide();
            });
          
            this.nav.setRoot(PreloginPage);  
          })      
        })            
      }
    );    
  }

  init(){
    console.log("init");

    if(this.globals.loginData){
      this.storage.get('role').then((role) => {
        this.globals.currentRole = role;     

        this.loadingMsg = "DONE!"   

        // //test
        // this.globals.messageId = 'CE39709D-CA7A-4832-A9B7-76DBD8D38E31';

        // this.handleNotificationClick(null);  
        console.log("DONE!");

        this.customSplashHandlerProvider.setMessage({
          msg: "Done!",
          finished: true
        });       
      });                        
    } else {    
      console.log("Has no login data!");

      this.loadingMsg = "No session found..."   
   
      this.platform.ready().then((readySource) => {
        this.splashScreen.hide();
      });

      // this.statusBar.styleDefault();
      this.nav.setRoot(PreloginPage);     
    }     
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts